import React from 'react';
import fitness from '../../images/fitness.PNG';
import fitness2 from '../../images/fitness2.PNG';
import fitness3 from '../../images/fitness3.PNG';
import crispy from '../../images/crispy.PNG';
import crispy2 from '../../images/Crispy2.PNG';
import crispy3 from '../../images/crispy3.PNG';
import soccer from "../../images/soccer.PNG";
import soccer2 from "../../images/soccer2.PNG";
import soccer3 from "../../images/soccer3.PNG";
import PortfolioDetails from '../PortfolioDetails/PortfolioDetails';
import Navbar from '../Shared/Navbar/Navbar';
import Footer from '../Shared/Footer/Footer';


const portfolioInfo =[
    {
        projectName : "Fitness Guru Full Stack Web App",
        description : "This site is basically about a training center which provide services like indoor cycling, yoga , special gym and so on. ",
        info1: "Includes login system with google sign-in and responsive (desktop and mobile view)",
        info2: "Users can book a service after login",
        info3:"They can complete their booking by doing the payment through a card and can review the system which will dynamically visible in the main UI.",
        info4: "There is another section for admin. Admin should logged-in to get access to the admin dashboard and he can add service, delete service, view all bookings, can make another user into admin Admin activities such as adding service, deleting service it will dynamically update the main UI.",
        technology : "React.js, React-Router, Private Route, Firebase Authentication, Axios, Bootstrap, ImgBB, MongoDB, Node.js, Express.js, and Heroku, Firebase for deployment",
        workPhoto1: fitness,
        workPhoto2 : fitness2,
        workPhoto3 : fitness3,
        link:"https://fitness-guru-37c01.web.app",
        source:"https://github.com/moon-saha-chowdhury/fitness-guru",
    },
    {
        projectName : "Crispy Snacks Full Stack Web App",
        description : "Basically it's a food ordering app. Includes features are",
        technology : "React.js, React-Router, Private Route, Firebase Authentication, Axios, Bootstrap, ImgBB, MongoDB, Node.js, Express.js, and Heroku, Firebase for deployment",
        info1:" Includes login system with google sign-in and responsive for (desktop and mobile view)",
        info2:"User can buy his/her desire snacks by choosing them, and users are able to check their orders what they have done before.",
        info3:"There is another section for admin. The admin can also add products and also can manage products by deleting them.",
        info4:"If admin add or, delete any product it will dynamically update the main UI.",
        workPhoto1 : crispy,
        workPhoto2 : crispy2,
        workPhoto3 : crispy3,
        link:"https://crispy-snacks.web.app",
        source:"https://github.com/moon-saha-chowdhury/crispy-snacks-client",
    },
    {
        projectName : "Top Soccer League 2020 Web App",
        description : "Through this app people can select their desire league and able to see the league details such as sport type, and so on.",
        technology:"React.js, Bootstrap, Netlify used for deployment.",
        info1:"Through this app people can select their desire league and able to see the specific league details such as sport type, founded year including all social site links and so on.",
        info2:"Fully responsive for any type of view.",
        info3:"API Reference: https://www.thesportsdb.com/api.php",
        info4:"Available social icon in footer section will take you to the specific leagues site as you have clicked previous",
        workPhoto1 : soccer,
        workPhoto2 : soccer2,
        workPhoto3 : soccer3,
        link:" https://laughing-benz-99e9dc.netlify.app/",
        source: "https://github.com/moon-saha-chowdhury/top-soccer-leagues",
    }
]

const Portfolio = () => {
    return (
        <div>
            <Navbar></Navbar>
           <div className="container my-5">
           <div className="container">
                    <div className="section-header text-center">
                        <h3 className="text-warning pt-3">Some Of My Projects</h3>
                    </div>
                           <div className=" ">
                           {
                                portfolioInfo.map(work =>
                                    <div style={{maxWidth:'940px'}} className="card my-5 mx-auto border border-4 border-warning rounded ">
                                        <PortfolioDetails work={work}>
                                        </PortfolioDetails></div> )
                            }
                           </div>

                    </div>
           </div>
          <Footer></Footer> 
            
        </div>
    );
};

export default Portfolio;